import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormArray, UntypedFormControl } from '@angular/forms';
import { SupportingDocumentation } from '../../claim-submission.model';
import { ClaimSubmissionService } from '../../claim-submission.service';
import { ClaimSubmissionDocumentData } from '../../submittedClaim';

@Component({
  selector: 'zip-supporting-documentation',
  templateUrl: './supporting-documentation.component.html',
  styleUrls: ['./supporting-documentation.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SupportingDocumentationComponent implements OnInit {
  @Input() config: SupportingDocumentation;
  @Input() context: ClaimSubmissionDocumentData[];
  documentContext: UntypedFormArray;
  disabled = false;

  constructor(public claimSubmissionService: ClaimSubmissionService) {}

  ngOnInit(): void {
    this.disabled = false;
    if (
      !this.claimSubmissionService.hasReturnedFromReviewPage &&
      this.context
    ) {
      this.claimSubmissionService.filesList = this.context;
    }
    if (this.claimSubmissionService.filesList?.length > 0) {
      this.setFilesFromAPI(this.claimSubmissionService.filesList);
    }
  }

  public setFilesFromAPI(filesList: ClaimSubmissionDocumentData[]): void {
    this.documentContext = new UntypedFormArray(
      filesList.map((file: File) => new UntypedFormControl(file)),
    );
  }

  fileUploaded(fileList): void {
    this.claimSubmissionService.uploadFile(
      fileList,
      this.config.documentUploadUrl,
    );
    if (this.config?.addDocumentationButton) {
      this.disabled = true;
    }
    this.claimSubmissionService.filesList = fileList;
  }

  removeFile(fileId: number) {
    this.claimSubmissionService.removeFile(fileId);
    this.claimSubmissionService.uploadCompleted$.next(false);
  }
}
